import {InjectionToken, Provider} from "@angular/core";

const version: string = "2";

export const MODULE_VERSIONS: InjectionToken<string> = new InjectionToken<string>('moduleVersions');

export const DataClientVersion: Provider = {
    provide: MODULE_VERSIONS,
    useValue: {
        "module": "data-client-api",
        "version": version
    },
    multi: true
};
